import React from 'react';
import useMetric from '../hooks/useMetric';
import CheckboxGroup from './CheckboxGroup';
import { RowWrapper } from '../styled';

const CategorySection = ({
  metrics,
  categoryKey,
  searchText,
  selectedMetricList,
  lockedMetricsSet,
  onChange,
  onBulkChange,
  setRefFn,
  categoryMeta,
  isFlow,
}) => {
  const { metricList, allSelected } = useMetric({
    currentMetrics: metrics,
    selectedMetricList,
    lockedMetricsSet,
  });

  return (
    <RowWrapper key={categoryKey}>
      <CheckboxGroup
        categoryMeta={categoryMeta}
        inputList={metricList}
        categoryKey={categoryKey}
        onChange={onChange}
        onBulkChange={onBulkChange}
        setRef={setRefFn(categoryKey)}
        groupChecked={allSelected}
        hasSearchText={!!searchText}
        emptyText={<>No metrics available</>}
        isFlow={isFlow}
      />
    </RowWrapper>
  );
};

export default CategorySection;
